module.exports = __webpack_public_path__ + "static/kapil-22274f3d281294ed1caea529172a8228.jpg";